const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnFullScreenXs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.649 136.315v3.136a1.031 1.031 0 0 1-2.063 0v-.651l-2.421 2.421a1.031 1.031 0 0 1-1.458-1.458l2.421-2.42h-.647a1.031 1.031 0 1 1 0-2.063h3.131a.926.926 0 0 1 .658.25c.024.021.054.029.076.052s.015.028.027.04a.976.976 0 0 1 .275.689zm-1.031 9.77a1.031 1.031 0 0 0-1.031 1.031v.647l-2.421-2.42a1.031 1.031 0 0 0-1.458 1.458l2.421 2.42h-.647a1.031 1.031 0 1 0 0 2.063h3.136a.938.938 0 0 0 .653-.252.9.9 0 0 0 .076-.051c.012-.012.015-.029.027-.041a1.031 1.031 0 0 0 .2-.294 1.044 1.044 0 0 0 .079-.395v-3.136a1.031 1.031 0 0 0-1.035-1.03zm-11.446-8.738h.645a1.031 1.031 0 1 0 0-2.063h-3.13a1.011 1.011 0 0 0-.712.286c-.006.006-.015.008-.023.015a.914.914 0 0 0-.282.624.887.887 0 0 0-.022.106v3.136a1.031 1.031 0 0 0 2.063 0v-.651l2.422 2.422a1.031 1.031 0 0 0 1.458-1.458zm.961 8-2.422 2.421v-.648a1.031 1.031 0 0 0-2.063 0v3.136a.978.978 0 0 0 .022.106.91.91 0 0 0 .282.623c.007.006.016.008.023.014a1.025 1.025 0 0 0 .311.206 1.011 1.011 0 0 0 .4.081h3.135a1.031 1.031 0 1 0 0-2.063h-.645l2.419-2.42a1.031 1.031 0 0 0-1.458-1.458z",
    transform: "translate(-630.649 -131.285)",
    style: {
      fill: "current"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnFullScreenXs);
export default __webpack_public_path__ + "static/media/btn-full-screen-xs.8794498ecfc828a20d9f27daefbec31b.svg";
export { ForwardRef as ReactComponent };